module.exports = __webpack_public_path__ + "img/van.f0547734.png";